(function () {
  function buildDots(grid) {
    if (!grid || grid.dataset.dotsInit) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('.multicolumn-grid-item'));
    if (items.length < 2) return;
    grid.dataset.dotsInit = '1';

    var nav = document.createElement('div');
    nav.className = 'home-press-dots';
    var dots = items.map(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'home-press-dot';
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      b.addEventListener('click', function () {
        item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      nav.appendChild(b);
      return b;
    });
    grid.parentNode.insertBefore(nav, grid.nextSibling);

    function setActive(idx) {
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === idx);
      }
    }
    setActive(0);

    var ratios = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { ratios.set(e.target, e.intersectionRatio); });
      var best = 0, bestRatio = -1;
      for (var i = 0; i < items.length; i++) {
        var r = ratios.get(items[i]) || 0;
        if (r > bestRatio) { bestRatio = r; best = i; }
      }
      setActive(best);
    }, { root: grid, threshold: [0, 0.25, 0.5, 0.75, 1] });
    items.forEach(function (it) { io.observe(it); });
  }

  function init() {
    var grids = document.querySelectorAll('.home-press .multicolumn-grid');
    for (var i = 0; i < grids.length; i++) buildDots(grids[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
